import React, { useCallback, useEffect } from "react";
import { WizardService } from "../../../services/WizardService";
import { List, Modal } from "antd";
import { CheckOutlined } from "@ant-design/icons";
import { Sdk } from "../../../types/sdk";
import { PlatformIcon } from "../../components/PlatformIcon";


export interface SuggestedSdkListProps {
  adapterId?: number;
  pluginId?: number;
  open: boolean;
  onSdksSelected?: (sdks: Sdk[]) => void;
  onClose?: () => void;
}

export const SuggestedSdkList = (props: SuggestedSdkListProps) => {
  const adaptersApi = WizardService.Adapter;
  const pluginsApi = WizardService.Plugin;

  const [sdks, setSdks] = React.useState<Sdk[]>([]);
  const [selected, setSelected] = React.useState<number[]>([]);

  const adapterFetch = useCallback(() => {
    props.adapterId &&
      adaptersApi.suggestedSdks(props.adapterId).then((sdks) => {
        setSdks(sdks);
      });
  }, [adaptersApi, props.adapterId]);

  const pluginFetch = useCallback(() => {
    props.pluginId &&
      pluginsApi.suggestedSdks(props.pluginId).then((sdks) => {
        setSdks(sdks);
      });
  }, [pluginsApi, props.pluginId]);

  useEffect(() => {
    if (props.open) {
      setSelected([]);
      adapterFetch();
      pluginFetch();
    }
  }, [adapterFetch, pluginFetch, props.open]);

  const handleOk = () => {
    const result = sdks.filter((sdk) => sdk.id && selected.includes(sdk.id));
    props.onSdksSelected?.(result);
    props.onClose?.();
  };

  const handleCancel = () => {
    setSelected([]);
    props.onClose?.();
  };

  return (
    <Modal
      open={props.open}
      title="Suggested Sdks"
      onOk={handleOk}
      onCancel={handleCancel}
    >
      <List
        dataSource={sdks}
        renderItem={(sdk) => (
          <List.Item
            onClick={() =>
              selected.includes(sdk.id!)
                ? setSelected((current) =>
                    current.filter((id) => id !== sdk.id)
                  )
                : setSelected([...selected, sdk.id!])
            }
          >
            <List.Item.Meta
              avatar={<PlatformIcon platform={sdk.platform} />}
              title={
                <>
                  {sdk.name} - {sdk.version}
                </>
              }
              description={<>{sdk.requirement.toLocaleUpperCase()}, {sdk.stability.toLocaleUpperCase()}</>}
            />
            {selected.includes(sdk.id!) && <CheckOutlined  />}
          </List.Item>
        )}
      ></List>
    </Modal>
  );
};
